export enum SelfFillRequestStatus {
    Pending = 0,
    Approved = 1,
    Reproved = 2,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/SelfFillRequestStatus.ts